import React from 'react';
import { PageHeading } from '../components/PageHeading';
import { pageHeroPhotos } from '../data/pageHeroPhotos';
import { ArrowUpRightIcon, PhoneIcon } from 'lucide-react';
import { SureCriticReviews } from '../components/SureCriticReviews';
import { business, reviewSummary, reviewThemes } from '../data/site';
import { usePageMeta } from '../hooks/usePageMeta';
export function Reviews() {
  usePageMeta('Reviews From East End Automotive Repair Customers | Oak Ridge, TN', 'Verified SureCritic reviews for East End Automotive Repair in Oak Ridge, TN. Call (865) 206-2279.');
  return <>
      <PageHeading eyebrow="Customer reviews" title="Reviews From East End Automotive Repair Customers" intro="Drivers in Oak Ridge and the surrounding area use East End Automotive Repair when they want a clear diagnosis, straightforward communication, and repair options they can understand." photo={{
      ...pageHeroPhotos.reviews,
      position: 'center 34%',
      mobilePosition: '70% 40%'
    }} secondaryAction={{
      href: reviewSummary.url,
      label: 'Read on SureCritic'
    }} data-id="element-629" data-mp="nejax87yyd3t" />

      <section className="w-full bg-white py-16 lg:py-24" data-id="element-630" data-mp="3tx2d8j8rdzh4">
        <div className="mx-auto max-w-shell min-w-0 px-5 lg:px-8" data-id="element-631" data-mp="bqfpx2dkt2ca">
          <h2 className="font-display text-[26px] font-extrabold leading-[1.1] tracking-[-0.02em] text-ink sm:text-[32px]" data-id="element-632" data-mp="brqtp270ua3e">
            Verified Customer Reviews
          </h2>
          <div className="mt-8" data-id="element-633" data-mp="lnalbcejymmc">
            <SureCriticReviews data-id="element-634" data-mp="lmio5x5b4gty" />
          </div>
        </div>
      </section>

      <section className="w-full bg-ink py-14 text-white lg:py-16" data-id="element-635" data-mp="gozb30kcia3l">
        <div className="mx-auto flex max-w-shell flex-col gap-7 px-5 lg:flex-row lg:items-center lg:justify-between lg:px-8" data-id="element-636" data-mp="veohpbb7j6b9">
          <div data-id="element-637" data-mp="qfu0gdsw1pt9">
            <h2 className="max-w-[520px] font-display text-[26px] font-extrabold leading-[1.1] tracking-[-0.02em] sm:text-[32px]" data-id="element-638" data-mp="qheum2baj6ql">
              Need a straight answer about your vehicle?
            </h2>
            <p className="mt-4 max-w-[540px] text-[16px] leading-relaxed text-chalk/70" data-id="element-639" data-mp="zdxbgg68z46t">
              Call East End Automotive Repair and talk through what your vehicle
              is doing. The fastest way to get an answer is to call the shop
              during business hours.
            </p>
          </div>
          <a href={business.phoneHref} className="inline-flex shrink-0 items-center justify-center gap-3 self-start whitespace-nowrap rounded-md bg-brand px-7 py-4 font-display text-lg font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-light lg:self-auto" data-id="element-640" data-mp="atz0l4r48kjk">
            <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-641" data-mp="pqq4nrbqikfi" />
            Call {business.phone}
          </a>
        </div>
      </section>

      <section className="w-full bg-chalk py-16 lg:py-20" data-id="element-642" data-mp="ts1w82e65fqc">
        <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-643" data-mp="2rjeb09jodnzi">
          <h2 className="font-display text-[26px] font-extrabold leading-[1.1] tracking-[-0.02em] text-ink sm:text-[32px]" data-id="element-644" data-mp="2rkz743ln1ezh">
            Common themes in the reviews
          </h2>
          <ul className="mt-8 grid gap-x-8 gap-y-7 sm:grid-cols-2 lg:grid-cols-3" data-id="element-645" data-mp="2o202jjp6u0np">
            {reviewThemes.map(theme => <li key={theme.title} className="rounded-lg border border-black/10 bg-white p-6" data-id="element-646" data-mp="2eavn6ivlodsc">
                <h3 className="font-display text-[17px] font-bold tracking-tight text-ink" data-id="element-647" data-mp="2aalh767t5ndh">
                  {theme.title}
                </h3>
                <p className="mt-2 text-[14.5px] leading-relaxed text-steel/70" data-id="element-648" data-mp="36x6wqj16pp1a">
                  {theme.copy}
                </p>
              </li>)}
          </ul>
        </div>
      </section>

      <section className="w-full bg-white py-16 lg:py-20" data-id="element-649" data-mp="2szs28zw2qr2g">
        <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-650" data-mp="2sz9xfevcj4ix">
          <h2 className="font-display text-[26px] font-extrabold leading-[1.1] tracking-[-0.02em] text-ink sm:text-[32px]" data-id="element-651" data-mp="1mk92nci24sdx">
            More verified reviews on SureCritic
          </h2>
          <p className="mt-4 max-w-[620px] text-[16px] leading-relaxed text-steel/75" data-id="element-652" data-mp="35hkpuzg7xh2z">
            East End’s full verified review profile is available on SureCritic.
          </p>
          <a href={reviewSummary.url} target="_blank" rel="noreferrer" className="mt-7 inline-flex max-w-full items-center justify-center gap-2 whitespace-normal rounded-md bg-ink px-4 py-3.5 text-center sm:whitespace-nowrap sm:px-6 text-[15px] font-bold text-white transition-colors duration-150 ease-out hover:bg-steel" data-id="element-653" data-mp="3a9vtaca63l0a">
            View all reviews on SureCritic
            <ArrowUpRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-654" data-mp="3f7nhav7oymz7" />
          </a>
        </div>
      </section>

      <section className="w-full bg-ink py-14 text-white lg:py-16" data-id="element-655" data-mp="3k55vp14h9uel">
        <div className="mx-auto flex max-w-shell flex-col gap-6 px-5 sm:flex-row sm:items-center sm:justify-between lg:px-8" data-id="element-656" data-mp="23s8l3tnb3z55">
          <h2 className="max-w-[560px] font-display text-[24px] font-extrabold leading-[1.15] tracking-[-0.02em] sm:text-[30px]" data-id="element-657" data-mp="28s3b7uz9ckp5">
            Ready to talk through your repair?
          </h2>
          <a href={business.phoneHref} className="inline-flex shrink-0 items-center justify-center gap-3 self-start whitespace-nowrap rounded-md bg-brand px-7 py-4 font-display text-lg font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-light sm:self-auto" data-id="element-658" data-mp="1w97olsaxb5ra">
            <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-659" data-mp="1hkbl88jtagx0" />
            Call {business.phone}
          </a>
        </div>
      </section>
    </>;
}